import { useState, useEffect, useRef } from 'react';
import './navbar.css';

const Navbar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const panelRef = useRef(null);
	const burgerRef = useRef(null);

	// Opaque Top Bar Menu
	useEffect(() => {
		const onScroll = () => {
			setIsScrolled(window.scrollY > 50);
		};
		window.addEventListener('scroll', onScroll);
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	// Close panel on outside click
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				panelRef.current &&
				!panelRef.current.contains(event.target) &&
				burgerRef.current &&
				!burgerRef.current.contains(event.target)
			) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [isOpen]);

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	const links = [
		{ name: 'Home', url: '#home' },
		{ name: 'About', url: '#me' },
		{ name: 'Experience', url: '#experience' },
		{ name: 'Projects', url: '#projects' },
		{ name: 'Contact', url: '#connect' },
	];

	return (
		<nav className="menu">
			<div className={`menu__bar ${isScrolled ? 'menu__bar--opaque' : ''}`}>
				<div className="menu__desktop">
					{links.map((link) => (
						<a className="menu__item" href={link.url} key={link.name}>
							{link.name}
						</a>
					))}
				</div>
				<button
					ref={burgerRef}
					className={`menu__burger ${isOpen ? 'menu__burger--active' : ''}`}
					onClick={toggleMenu}
					aria-label="Toggle menu"
				>
					<span className="menu__burger-line" />
					<span className="menu__burger-line" />
					<span className="menu__burger-line" />
				</button>
			</div>
			<div className={`panel__overlay ${isOpen ? 'panel__overlay--visible' : ''}`} />
			<Panel isOpen={isOpen} links={links} toggle={toggleMenu} panelRef={panelRef} />
		</nav>
	);
};

const Panel = ({ isOpen, links, toggle, panelRef }) => {
	return (
		<div className={`panel ${isOpen ? 'panel--open' : ''}`} ref={panelRef}>
			<div className="panel__scanline" />
			<div className="panel__items">
				{links.map((link, index) => (
					<a
						href={link.url}
						onClick={toggle}
						key={link.name}
						className={`panel__link ${isOpen ? 'panel__link--visible' : ''}`}
						style={{ transitionDelay: isOpen ? `${0.2 + index * 0.08}s` : '0s' }}
					>
						<span className="panel__link-index">{'0' + (index + 1)}</span>
						<span className="panel__link-text">{link.name}</span>
					</a>
				))}
			</div>
		</div>
	);
};

export default Navbar;
